// Import and register all your controllers from Vite via controllers/**/*_controller

import { application } from "./application.js"

import { registerControllers } from 'stimulus-vite-helpers'
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)

// Import component controllers
const componentControllers = import.meta.glob('../../components/**/*_controller.js', { eager: true })
registerControllers(application, componentControllers)
